import {SectionItem} from 'common/components/items-menu/types';
import {TooltipSection} from 'common/components/chart-tooltip/types';

import type {SankeyEdge} from './sankey-edge';
import type {SankeyNode} from './sankey-node';
import type {SankeyBreakdown} from './sanky-breakdown';

export enum SankeyNodeType {
  Anchor = `ANCHOR`,
  Dropoff = `DROPOFF`,
  Pruned = `PRUNED`,
  Event = `NORMAL`,
  Forward = `FORWARD`,
  Reverse = `REVERSE`,
}

export enum SankeyStepType {
  Anchor = `ANCHOR`,
  Forward = `FORWARD`,
  Reverse = `REVERSE`,
}

export enum SankeyAnchorType {
  Normal = `NORMAL`,
  RelativeReverse = `RELATIVE_REVERSE`,
  RelativeForward = `RELATIVE_FORWARD`,
}

export const SankeyNodeTypePriority = {
  [SankeyNodeType.Dropoff]: 0,
  [SankeyNodeType.Pruned]: 1,
  [SankeyNodeType.Event]: 2,
  [SankeyNodeType.Forward]: 2,
  [SankeyNodeType.Reverse]: 2,
  [SankeyNodeType.Anchor]: 3,
};

export enum Alignment {
  LEFT,
  RIGHT,
}

export const AlignmentOptions: {[key in Alignment]: SectionItem} = {
  [Alignment.LEFT]: {
    icon: `left-align`,
    label: ({t}) => t(`flows.alignment.analyze-after`),
    value: Alignment.LEFT,
  },
  [Alignment.RIGHT]: {
    icon: `right-align`,
    label: ({t}) => t(`flows.alignment.analyze-before`),
    value: Alignment.RIGHT,
  },
};
export const AlignmentOptionsTrackingLabel = {
  [Alignment.LEFT]: `Analyze Events After`,
  [Alignment.RIGHT]: `Analyze Events Before`,
};

interface SankeyTooltip {
  clientX: number;
  clientY: number;
}

export interface LinkTooltip extends SankeyTooltip {
  edge: SankeyEdge;
  breakdown: SankeyBreakdown;
}

export interface NodeTooltip extends SankeyTooltip {
  sections: TooltipSection[];
}

export type NodeMenuEvent = CustomEvent<{
  node: SankeyNode;
  breakdown: SankeyBreakdown;
  pageX: number;
  pageY: number;
}>;
